import { render } from "./laboratoryEquipment.vue?vue&type=template&id=099b6a8d&scoped=true"
import script from "./laboratoryEquipment.vue?vue&type=script&lang=js"
export * from "./laboratoryEquipment.vue?vue&type=script&lang=js"

import "./laboratoryEquipment.vue?vue&type=style&index=0&id=099b6a8d&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099b6a8d"]])

export default __exports__